import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ServizioPubblicoDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ServizioPubblicoApiClient extends BaseCRUDApiClient<ServizioPubblicoDto> {
  baseUrl = this.config.apiEndpoint + '/servizio-pubblico';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
